(function () {
  var THRESHOLD = 20000;

  function formatPHP(value) {
    return '₱' + Number(value || 0).toLocaleString('en-PH');
  }

  function updateProcurementUI(cart) {
    var progress = document.getElementById('procurement-progress');
    var button = document.getElementById('cart-quickpay');

    if (!progress || !button || !cart) return;

    var total = (cart.total_price || 0) / 100;
    var enabled = total >= THRESHOLD;

    progress.textContent = formatPHP(total);

    button.setAttribute('data-cart-quickpay-enabled', enabled ? 'true' : 'false');
    button.setAttribute('aria-disabled', enabled ? 'false' : 'true');

    if (enabled) {
      button.classList.remove('is-disabled');
      button.textContent = 'QuickPay · CoopPay';
    } else {
      button.classList.add('is-disabled');
      button.textContent = 'QuickPay · CoopPay';
    }
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateProcurementUI(cart);
      })
      .catch(function (err) {
        console.error('cart-procurement.js error:', err);
      });
  }

  document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
  document.addEventListener('cart:refresh', fetchCartAndUpdate);
  document.addEventListener('cart:updated', fetchCartAndUpdate);

  document.addEventListener('click', function () {
    setTimeout(fetchCartAndUpdate, 300);
  });
})();